<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';

    import {sgettext} from '../../../i18n.js';
    import {get, getSetting} from '../../../utils.js';
    import Button from '../../Button.svelte';
    import Panel from '../../Layout/Panel.svelte';
    import Modal from '../../Modal.svelte';
    import { primaryColour } from '../../styles/theme.js';
    import TabView from '../../TabView/TabView.svelte';
    import {setActiveTab} from '../../TabView/TabView.svelte';

    import { elementTabs } from '../tabStore.js';
    import {
        draftElementDetails, elementDetails, standaloneEdit, readOnly, triggerNewDraftElementVersionCreation
    } from '../workspacesStore';

    let tabs = {};
    $: newElementState = $draftElementDetails && $draftElementDetails.elementId === 0;
    $: currentVersionExists = $elementDetails && $elementDetails.status? $elementDetails.status.toLowerCase() === 'current': false;
    $: elementIsArchived = $elementDetails ? $elementDetails.expired : false;
    $: elementIdText = $elementDetails? `(${sgettext('$$ELEMENT$$')}: ${$elementDetails.elementId})` : '';
    $: elementName = $elementDetails ? `: ${$elementDetails.name}` : '';
    $: elementId = $elementDetails? $elementDetails.elementId : 0;
    $: eevId = $elementDetails? $elementDetails.eevId : 0;

    getTabs();

    export let elementFromAPM = false;
    export let leftColumnWidth;

    function getTabs() {
        Object.keys($elementTabs).forEach((k) => {
            if (!$elementTabs[k].hide) {
                tabs[k] = { ...$elementTabs[k] };
            }
        });
    }

    let newVersionWarningModalId = 'newVersionWarningModal';
    let draftElementVersionViewApiUrl = `${PATH_PREFIX}/sw/api/elements_database/draft_element_version/`;
    async function newVersion() {
        elementTabs.set(setActiveTab('edit', $elementTabs));

        if ($draftElementDetails !== null) {
            jQuery(`#${newVersionWarningModalId}`).modal('show');
        }
        else {
            triggerNewDraftElementVersionCreation.set(true);
        }
    }
</script>

<style>
    .slot-body {
        height: 100%;
    }
</style>

{#if $standaloneEdit}
    <Panel
        title="{sgettext('$$ELEMENT_CONTENT$$')} {elementName}"
        collapsible={false}
        {elementIdText}
        padded={false}
        hideOverflowX={true}
        hideOverflowY={true}
        headerColour={primaryColour}
        style="background-color: #e9ecef">
        <div slot="header"></div>
        <div class="slot-body" slot="body">
            <TabView tabs={$elementTabs} fixedTabs={true}>
                <div slot="right-nav">
                    <div class="d-inline-block pr-1">
                        {#if !$readOnly}
                        <Button
                                name={sgettext('$$NEW_VERSION$$')}
                                type="primary"
                                hidden={newElementState || elementIsArchived || $draftElementDetails !== null}
                                on:click={newVersion}>
                            <div slot="text"><i class="fa fa-plus"></i> {sgettext('$$NEW_VERSION$$')}</div>
                        </Button>
                        {/if}
                        <div class="dropdown" class:d-inline-block={!newElementState && currentVersionExists && !elementIsArchived} class:d-none={newElementState || !currentVersionExists || elementIsArchived}>
                            <button class="btn btn-secondary dropdown-toggle" type="button" id="elementDuplicationDropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {sgettext('$$DUPLICATE$$')}
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="elementDuplicationDropdownMenuButton">
                                <a class="dropdown-item" href="javascript:genericModal('{`${PATH_PREFIX}/sw/elements_database/${elementId}/clone/`}', 'Linked Copy', 400)">{sgettext('$$LINKED_COPY$$')}</a>
                                <a class="dropdown-item" href="javascript:genericModal('{`${PATH_PREFIX}/sw/elements_database/${elementId}/copy/`}', 'Unlinked Copy', 600)">{sgettext('$$UNLINKED_COPY$$')}</a>
                            </div>
                        </div>
                        <div class="dropdown" class:d-inline-block={!newElementState} class:d-none={newElementState}>
                            <button class="btn btn-outline dropdown-toggle dropdown-no-caret" type="button" id="elementDropdownMenuButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa fa-ellipsis-v"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="elementDropdownMenuButton">
                                {#if !$readOnly}
                                <a class="dropdown-item" href="{`${PATH_PREFIX}/sw/elements_database/eev/${eevId}/`}">{sgettext('$$LEGACY_EDITOR$$')}</a>
                                {/if}
                                <a class="dropdown-item" href="{`${PATH_PREFIX}/sw/common/auditlog/element/${elementId}/`}">{sgettext('$$LOGS$$')}</a>
                                {#if !elementIsArchived && !$readOnly}
                                    {#if elementFromAPM}
                                        <a class="dropdown-item disabled" href="#"
                                        title="{sgettext("$$CANNOT_EXPIRE_ELEMENT_CREATED_APM$$")}" style="pointer-events: auto;">{sgettext('$$EXPIRE$$')}</a>
                                    {:else}
                                        <a class="dropdown-item" href="javascript:genericModal('{`${PATH_PREFIX}/sw/elements_database/${elementId}/delete/`}', 'Expire', 400)">{sgettext('$$EXPIRE$$')}</a>
                                    {/if}
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </TabView>
        </div>
    </Panel>

    <Modal id={newVersionWarningModalId} title={sgettext('$$NEW_VERSION$$')}>
        <div slot="body">
            <p>{sgettext('$$DRAFT_VERSION_ALREADY_EXISTS$$')}</p>
        </div>

        <div slot="footer">
            <Button name={sgettext('$$OK_1$$')} on:click={() => jQuery(`#${newVersionWarningModalId}`).modal('hide')}/>
        </div>
    </Modal>
{:else}
    <Panel
        title="{sgettext('$$ELEMENT_CONTENT$$')} {elementName}"
        collapsible={false}
        padded={false}
        hideOverflow={true}
        headerColour={primaryColour}
        showEllipsis={true}
        {elementIdText}
        rightPanelWidth = {window.screen.width - leftColumnWidth}
        style="background-color: #e9ecef">
        <div class="slot-body" slot="body">
            <TabView tabs={$elementTabs} />
        </div>
    </Panel>
{/if}
